var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5A6.48 6.48 0 016.24 12H12v-2H5.58c-.05-.33-.08-.66-.08-1 0-.34.03-.67.08-1H12V6H6.24A6.491 6.491 0 0112 2.5c1.61 0 3.09.59 4.23 1.57L18 2.3A8.955 8.955 0 0012 0C8.08 0 4.76 2.51 3.52 6H0v2h3.06a8.262 8.262 0 000 2H0v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z",
    fill: "#fff"
  })));
}

export default SvgEuro;